// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* .benefits-section {
  padding: 6rem 1rem;
}

.benefits-container {
  max-width: 1200px;
  margin: 0 auto;
}

.tab-switcher {
  display: flex;
  justify-content: center;
  margin-bottom: 4rem;
  background: white;
  border-radius: 50px;
  padding: 4px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);
  max-width: 400px;
  margin-left: auto;
  margin-right: auto;
}

.tab-button {
  padding: 0.8rem 2rem;
  font-size: 1.1rem;
  font-weight: 600;
  border: none;
  background: transparent;
  border-radius: 50px;
  cursor: pointer;
  transition: all 0.3s ease;
  font-family: 'Poppins', sans-serif;
}

.tab-button.active {
  background: #2563eb;
  color: white;
}

.section-title {
  font-size: 2.5rem;
  font-weight: 700;
  color: #1e293b;
  margin-bottom: 1.5rem;
}

.section-description {
  font-size: 1.2rem;
  color: #64748b;
  margin-bottom: 2.5rem;
  max-width: 600px;
}

.section-header {
  text-align: center;
  max-width: 800px;
  margin: 0 auto 4rem;
  padding: 0 1rem;
}

.benefits-card-container {
  display: grid;
  gap: 4rem;
}

@media (min-width: 992px) {
  .benefits-card-container {
    grid-template-columns: 1fr 1fr;
    align-items: center;
  }
}

.card {
  background: white;
  border-radius: 16px;
  padding: 2rem;
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;
  height: 100%;
}

.card:hover {
  transform: translateY(-5px);
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1);
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1.5rem;
}

.card-header h3 {
  font-size: 1.25rem;
  font-weight: 600;
  color: #1e293b;
}

.card-icon {
  width: 50px;
  height: 50px;
  background: #dbeafe;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 1.5rem;
}

.card-icon svg {
  width: 24px;
  height: 24px;
  color: #2563eb;
}

.card h3 {
  font-size: 1.25rem;
  font-weight: 600;
  color: #1e293b;
  margin-bottom: 0.75rem;
}

.card p {
  color: #64748b;
  line-height: 1.6;
}

.score-card {
  background: white;
  border-radius: 16px;
  padding: 2rem;
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.05);
  max-width: 500px;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.score-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1.5rem;
}

.score-header h3 {
  font-size: 1.25rem;
  font-weight: 600;
  color: #1e293b;
}

.overall-score {
  background: #dbeafe;
  color: #2563eb;
  font-weight: 700;
  padding: 0.5rem 1.25rem;
  border-radius: 50px;
}

.score-categories {
  display: grid;
  gap: 1.5rem;
}

.category-header {
  display: flex;
  justify-content: space-between;
  margin-bottom: 0.5rem;
  font-size: 0.95rem;
  color: #475569;
}

.progress-bar {
  height: 8px;
  background: #e2e8f0;
  border-radius: 4px;
  overflow: hidden;
}

.progress-fill {
  height: 100%;
  border-radius: 4px;
}

.education {
  background: #10b981;
}

.transport {
  background: #3b82f6;
}

.parks {
  background: #f59e0b;
}

.benefits-cards {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 1.5rem;
}

.benefits-list {
  display: grid;
  gap: 1.5rem;
}

.benefit-item {
  display: flex;
  gap: 1rem;
  padding: 1.5rem;
  background: white;
  border-radius: 12px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;
}

.benefit-item:hover {
  transform: translateY(-3px);
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1);
}

.benefit-icon {
  width: 50px;
  height: 50px;
  background: #dbeafe;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.benefit-icon svg {
  width: 24px;
  height: 24px;
  color: #2563eb;
}

.benefit-item h3 {
  font-size: 1.25rem;
  font-weight: 600;
  color: #1e293b;
  margin-bottom: 0.25rem;
}

.benefit-item p {
  color: #64748b;
  font-size: 1rem;
  line-height: 1.6;
}

.agents-text {
  height: 100%;
  display: flex;
  flex-direction: column;
}

.signup-details {
  background: white;
  border-radius: 16px;
  padding: 2rem;
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.05);
  max-width: 600px;
  margin: 0 auto;
  height: 100%;
}

.signup-steps {
  list-style: none;
  padding: 0;
  margin: 1rem 0 2rem;
}

.signup-steps li {
  margin-bottom: 1.5rem;
}

.signup-steps strong {
  display: block;
  font-size: 1.25rem;
  margin-bottom: 0.25rem;
  color: #1e293b;
}

.signup-steps p {
  margin: 0;
  color: #64748b;
  font-size: 1rem;
}

.step {
  display: flex;
  gap: 1.5rem;
  align-items: flex-start;
  padding: 1.5rem;
  background: white;
  border-radius: 12px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;
}

.step:hover {
  transform: translateY(-3px);
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1);
}

.step-icon {
  width: 50px;
  height: 50px;
  background: #dbeafe;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.step-icon svg {
  width: 24px;
  height: 24px;
  color: #2563eb;
}

.step-content h3 {
  font-size: 1.25rem;
  font-weight: 600;
  color: #1e293b;
  margin-bottom: 0.5rem;
}

.step-content p {
  color: #64748b;
  font-size: 1rem;
  line-height: 1.6;
  margin: 0;
}

.cta-buttons {
  display: flex;
  gap: 1rem;
  margin-top: 2rem;
  justify-content: center;
}

.cta-button {
  padding: 0.75rem 1.5rem;
  font-family: 'Poppins', sans-serif;
  font-size: 1rem;
  font-weight: 600;
  border: none;
  border-radius: 50px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.cta-button.primary {
  background: #2563eb;
  color: #fff;
}

.cta-button.primary:hover {
  background: #1e40af;
}

.cta-button.secondary {
  background: #fff;
  color: #2563eb;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);
}

.cta-button.secondary:hover {
  background: #f1f5f9;
}

.demo-form {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin-top: 1.5rem;
}

.demo-form input,
.demo-form textarea {
  font-family: inherit;
  font-size: 1rem;
  padding: 0.75rem 1rem;
  border: 1px solid #cbd5e1;
  border-radius: 0.5rem;
  outline: none;
  resize: vertical;
}

.demo-form input:focus,
.demo-form textarea:focus {
  border-color: #2563eb;
  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.2);
}

.submit-demo {
  background: linear-gradient(to right, #3b82f6, #2563eb);
  color: #fff;
  padding: 0.75rem 2rem;
  font-family: inherit;
  font-size: 1rem;
  font-weight: 600;
  border: none;
  border-radius: 50px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  cursor: pointer;
  transition: all 0.3s ease;
  align-self: center;
  margin-top: 1.5rem;
}

.submit-demo:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);
} */








/* Updated unified styling for both sections */
.benefits-section {
  padding: 6rem 1rem;
}

.benefits-container {
  max-width: 1200px;
  margin: 0 auto;
}

.tab-switcher {
  display: flex;
  justify-content: center;
  margin-bottom: 4rem;
  background: white;
  border-radius: 50px;
  padding: 4px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);
  max-width: 400px;
  margin-left: auto;
  margin-right: auto;
}

.tab-button {
  padding: 0.8rem 2rem;
  font-size: 1.1rem;
  font-weight: 600;
  border: none;
  background: transparent;
  border-radius: 50px;
  cursor: pointer;
  transition: all 0.3s ease;
  font-family: 'Poppins', sans-serif;
}

.tab-button.active {
  background: #2563eb;
  color: white;
}

/* Section Header - Title above description */
.section-header {
  text-align: center;
  max-width: 800px;
  margin: 0 auto 3rem;
  padding: 0 1rem;

  display: flex;
  flex-direction: column;
}

.section-title {
  font-size: 2.5rem;
  font-weight: 700;
  color: #1e293b;
  margin-bottom: 1rem;
  order: 1;
}

/* .section-description {
  font-size: 1.2rem;
  color: #64748b;
  margin-bottom: 0;
  line-height: 1.6;
} */

.section-description {
  font-size: 1.2rem;
  color: #64748b;
  line-height: 1.6;
  margin-top: 0;
  order: 2; /* Explicitly places description second */
  padding: 0 1rem; /* Adds some horizontal padding */
}

/* Unified card container */
.benefits-card-container {
  display: grid;
  gap: 2rem;
  align-items: stretch;
}

@media (min-width: 992px) {
  .benefits-card-container {
    grid-template-columns: 1fr 1fr;
  }
}

/* Score card */
.score-card {
  background: white;
  border-radius: 16px;
  padding: 2rem;
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.05);
  height: 100%;
  display: flex;
  flex-direction: column;
}

.score-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1.5rem;
}

.score-header h3 {
  font-size: 1.25rem;
  font-weight: 600;
  color: #1e293b;
}

.overall-score {
  background: #dbeafe;
  color: #2563eb;
  font-weight: 700;
  padding: 0.5rem 1.25rem;
  border-radius: 50px;
}

.score-categories {
  display: grid;
  gap: 1.5rem;
}

.category-header {
  display: flex;
  justify-content: space-between;
  margin-bottom: 0.5rem;
  font-size: 0.95rem;
  color: #475569;
}

.progress-bar {
  height: 8px;
  background: #e2e8f0;
  border-radius: 4px;
  overflow: hidden;
  margin-top: 0.5rem;
}

.progress-fill {
  height: 100%;
  border-radius: 4px;
}

.education {
  background: #10b981;
}

.transport {
  background: #3b82f6;
}

.parks {
  background: #f59e0b;
}

/* Benefit cards */
.benefits-cards {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 1.5rem;
}

.card {
  background: white;
  border-radius: 16px;
  padding: 2rem;
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.card:hover {
  transform: translateY(-5px);
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1);
}

.card-icon {
  width: 50px;
  height: 50px;
  background: #dbeafe;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 1.5rem;
}

.card-icon svg {
  width: 24px;
  height: 24px;
  color: #2563eb;
}

.card h3 {
  font-size: 1.25rem;
  font-weight: 600;
  color: #1e293b;
  margin-bottom: 0.75rem;
}

.card p {
  color: #64748b;
  line-height: 1.6;
  margin-bottom: 0;
}

/* Agents section */
.agents-text {
  height: 100%;
  display: flex;
  flex-direction: column;
}

.benefits-list {
  display: grid;
  gap: 1.5rem;
}

.benefit-item {
  display: flex;
  gap: 1rem;
  padding: 1.5rem;
  background: white;
  border-radius: 12px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;
}

.benefit-item:hover {
  transform: translateY(-3px);
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1);
}

.benefit-icon {
  width: 50px;
  height: 50px;
  background: #dbeafe;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.benefit-icon svg {
  width: 24px;
  height: 24px;
  color: #2563eb;
}

.benefit-item h3 {
  font-size: 1.25rem;
  font-weight: 600;
  color: #1e293b;
  margin-bottom: 0.25rem;
}

.benefit-item p {
  color: #64748b;
  font-size: 1rem;
  line-height: 1.6;
  margin: 0;
}

/* Signup steps */
.signup-details {
  background: white;
  border-radius: 16px;
  padding: 2rem;
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.05);
  height: 100%;
}

.signup-steps {
  list-style: none;
  padding: 0;
  margin: 1rem 0 2rem;
}

.step {
  display: flex;
  gap: 1.5rem;
  align-items: flex-start;
  padding: 1.5rem;
  background: white;
  border-radius: 12px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;
  margin-bottom: 1rem;
}

.step:hover {
  transform: translateY(-3px);
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1);
}

.step-icon {
  width: 50px;
  height: 50px;
  background: #dbeafe;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.step-icon svg {
  width: 24px;
  height: 24px;
  color: #2563eb;
}

.step-content h3 {
  font-size: 1.25rem;
  font-weight: 600;
  color: #1e293b;
  margin-bottom: 0.5rem;
}

.step-content p {
  color: #64748b;
  font-size: 1rem;
  line-height: 1.6;
  margin: 0;
}

/* CTA buttons */
.cta-buttons {
  display: flex;
  gap: 1rem;
  margin-top: 2rem;
  justify-content: center;
}

.cta-button {
  padding: 0.75rem 1.5rem;
  font-family: 'Poppins', sans-serif;
  font-size: 1rem;
  font-weight: 600;
  border: none;
  border-radius: 50px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.cta-button.primary {
  background: #2563eb;
  color: #fff;
}

.cta-button.primary:hover {
  background: #1e40af;
}

.cta-button.secondary {
  background: #fff;
  color: #2563eb;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);
}

.cta-button.secondary:hover {
  background: #f1f5f9;
}

/* Demo form */
.demo-form {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin-top: 1.5rem;
}

.demo-form input,
.demo-form textarea {
  font-family: inherit;
  font-size: 1rem;
  padding: 0.75rem 1rem;
  border: 1px solid #cbd5e1;
  border-radius: 0.5rem;
  outline: none;
  resize: vertical;
}

.demo-form input:focus,
.demo-form textarea:focus {
  border-color: #2563eb;
  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.2);
}

.submit-demo {
  background: linear-gradient(to right, #3b82f6, #2563eb);
  color: #fff;
  padding: 0.75rem 2rem;
  font-family: inherit;
  font-size: 1rem;
  font-weight: 600;
  border: none;
  border-radius: 50px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  cursor: pointer;
  transition: all 0.3s ease;
  align-self: center;
  margin-top: 1.5rem;
}

.submit-demo:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);
}`, "",{"version":3,"sources":["webpack://./src/components/BenefitsSection2.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;GAmaG;;;;;;;;;AASH,8CAA8C;AAC9C;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;EACZ,yCAAyC;EACzC,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,kCAAkC;AACpC;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA,6CAA6C;AAC7C;EACE,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;;EAEf,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,QAAQ;AACV;;AAEA;;;;;GAKG;;AAEH;EACE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,aAAa;EACb,QAAQ,EAAE,yCAAyC;EACnD,eAAe,EAAE,iCAAiC;AACpD;;AAEA,2BAA2B;AAC3B;EACE,aAAa;EACb,SAAS;EACT,oBAAoB;AACtB;;AAEA;EACE;IACE,8BAA8B;EAChC;AACF;;AAEA,eAAe;AACf;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,gDAAgD;EAChD,YAAY;EACZ,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,qBAAqB;EACrB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,2DAA2D;EAC3D,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,gDAAgD;EAChD,yBAAyB;EACzB,YAAY;EACZ,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,mBAAmB;AACnB;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,yCAAyC;EACzC,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,SAAS;AACX;;AAEA,iBAAiB;AACjB;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,gDAAgD;EAChD,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,uBAAuB;EACvB,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,yCAAyC;EACzC,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,SAAS;AACX;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;EACvB,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,yCAAyC;AAC3C;;AAEA;EACE,mBAAmB;AACrB;;AAEA,cAAc;AACd;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,kBAAkB;AACpB;;AAEA;;EAEE,oBAAoB;EACpB,eAAe;EACf,qBAAqB;EACrB,yBAAyB;EACzB,qBAAqB;EACrB,aAAa;EACb,gBAAgB;AAClB;;AAEA;;EAEE,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;EACE,uDAAuD;EACvD,WAAW;EACX,qBAAqB;EACrB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;EACnB,wCAAwC;EACxC,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;EAC3B,0CAA0C;AAC5C","sourcesContent":["/* .benefits-section {\n  padding: 6rem 1rem;\n}\n\n.benefits-container {\n  max-width: 1200px;\n  margin: 0 auto;\n}\n\n.tab-switcher {\n  display: flex;\n  justify-content: center;\n  margin-bottom: 4rem;\n  background: white;\n  border-radius: 50px;\n  padding: 4px;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);\n  max-width: 400px;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.tab-button {\n  padding: 0.8rem 2rem;\n  font-size: 1.1rem;\n  font-weight: 600;\n  border: none;\n  background: transparent;\n  border-radius: 50px;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  font-family: 'Poppins', sans-serif;\n}\n\n.tab-button.active {\n  background: #2563eb;\n  color: white;\n}\n\n.section-title {\n  font-size: 2.5rem;\n  font-weight: 700;\n  color: #1e293b;\n  margin-bottom: 1.5rem;\n}\n\n.section-description {\n  font-size: 1.2rem;\n  color: #64748b;\n  margin-bottom: 2.5rem;\n  max-width: 600px;\n}\n\n.section-header {\n  text-align: center;\n  max-width: 800px;\n  margin: 0 auto 4rem;\n  padding: 0 1rem;\n}\n\n.benefits-card-container {\n  display: grid;\n  gap: 4rem;\n}\n\n@media (min-width: 992px) {\n  .benefits-card-container {\n    grid-template-columns: 1fr 1fr;\n    align-items: center;\n  }\n}\n\n.card {\n  background: white;\n  border-radius: 16px;\n  padding: 2rem;\n  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.05);\n  transition: all 0.3s ease;\n  height: 100%;\n}\n\n.card:hover {\n  transform: translateY(-5px);\n  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1);\n}\n\n.card-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 1.5rem;\n}\n\n.card-header h3 {\n  font-size: 1.25rem;\n  font-weight: 600;\n  color: #1e293b;\n}\n\n.card-icon {\n  width: 50px;\n  height: 50px;\n  background: #dbeafe;\n  border-radius: 12px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: 1.5rem;\n}\n\n.card-icon svg {\n  width: 24px;\n  height: 24px;\n  color: #2563eb;\n}\n\n.card h3 {\n  font-size: 1.25rem;\n  font-weight: 600;\n  color: #1e293b;\n  margin-bottom: 0.75rem;\n}\n\n.card p {\n  color: #64748b;\n  line-height: 1.6;\n}\n\n.score-card {\n  background: white;\n  border-radius: 16px;\n  padding: 2rem;\n  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.05);\n  max-width: 500px;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n}\n.score-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 1.5rem;\n}\n\n.score-header h3 {\n  font-size: 1.25rem;\n  font-weight: 600;\n  color: #1e293b;\n}\n\n.overall-score {\n  background: #dbeafe;\n  color: #2563eb;\n  font-weight: 700;\n  padding: 0.5rem 1.25rem;\n  border-radius: 50px;\n}\n\n.score-categories {\n  display: grid;\n  gap: 1.5rem;\n}\n\n.category-header {\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: 0.5rem;\n  font-size: 0.95rem;\n  color: #475569;\n}\n\n.progress-bar {\n  height: 8px;\n  background: #e2e8f0;\n  border-radius: 4px;\n  overflow: hidden;\n}\n\n.progress-fill {\n  height: 100%;\n  border-radius: 4px;\n}\n\n.education {\n  background: #10b981;\n}\n\n.transport {\n  background: #3b82f6;\n}\n\n.parks {\n  background: #f59e0b;\n}\n\n.benefits-cards {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));\n  gap: 1.5rem;\n}\n\n.benefits-list {\n  display: grid;\n  gap: 1.5rem;\n}\n\n.benefit-item {\n  display: flex;\n  gap: 1rem;\n  padding: 1.5rem;\n  background: white;\n  border-radius: 12px;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);\n  transition: all 0.3s ease;\n}\n\n.benefit-item:hover {\n  transform: translateY(-3px);\n  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1);\n}\n\n.benefit-icon {\n  width: 50px;\n  height: 50px;\n  background: #dbeafe;\n  border-radius: 12px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n\n.benefit-icon svg {\n  width: 24px;\n  height: 24px;\n  color: #2563eb;\n}\n\n.benefit-item h3 {\n  font-size: 1.25rem;\n  font-weight: 600;\n  color: #1e293b;\n  margin-bottom: 0.25rem;\n}\n\n.benefit-item p {\n  color: #64748b;\n  font-size: 1rem;\n  line-height: 1.6;\n}\n\n.agents-text {\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n}\n\n.signup-details {\n  background: white;\n  border-radius: 16px;\n  padding: 2rem;\n  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.05);\n  max-width: 600px;\n  margin: 0 auto;\n  height: 100%;\n}\n\n.signup-steps {\n  list-style: none;\n  padding: 0;\n  margin: 1rem 0 2rem;\n}\n\n.signup-steps li {\n  margin-bottom: 1.5rem;\n}\n\n.signup-steps strong {\n  display: block;\n  font-size: 1.25rem;\n  margin-bottom: 0.25rem;\n  color: #1e293b;\n}\n\n.signup-steps p {\n  margin: 0;\n  color: #64748b;\n  font-size: 1rem;\n}\n\n.step {\n  display: flex;\n  gap: 1.5rem;\n  align-items: flex-start;\n  padding: 1.5rem;\n  background: white;\n  border-radius: 12px;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);\n  transition: all 0.3s ease;\n}\n\n.step:hover {\n  transform: translateY(-3px);\n  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1);\n}\n\n.step-icon {\n  width: 50px;\n  height: 50px;\n  background: #dbeafe;\n  border-radius: 12px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n\n.step-icon svg {\n  width: 24px;\n  height: 24px;\n  color: #2563eb;\n}\n\n.step-content h3 {\n  font-size: 1.25rem;\n  font-weight: 600;\n  color: #1e293b;\n  margin-bottom: 0.5rem;\n}\n\n.step-content p {\n  color: #64748b;\n  font-size: 1rem;\n  line-height: 1.6;\n  margin: 0;\n}\n\n.cta-buttons {\n  display: flex;\n  gap: 1rem;\n  margin-top: 2rem;\n  justify-content: center;\n}\n\n.cta-button {\n  padding: 0.75rem 1.5rem;\n  font-family: 'Poppins', sans-serif;\n  font-size: 1rem;\n  font-weight: 600;\n  border: none;\n  border-radius: 50px;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.cta-button.primary {\n  background: #2563eb;\n  color: #fff;\n}\n\n.cta-button.primary:hover {\n  background: #1e40af;\n}\n\n.cta-button.secondary {\n  background: #fff;\n  color: #2563eb;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);\n}\n\n.cta-button.secondary:hover {\n  background: #f1f5f9;\n}\n\n.demo-form {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n  margin-top: 1.5rem;\n}\n\n.demo-form input,\n.demo-form textarea {\n  font-family: inherit;\n  font-size: 1rem;\n  padding: 0.75rem 1rem;\n  border: 1px solid #cbd5e1;\n  border-radius: 0.5rem;\n  outline: none;\n  resize: vertical;\n}\n\n.demo-form input:focus,\n.demo-form textarea:focus {\n  border-color: #2563eb;\n  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.2);\n}\n\n.submit-demo {\n  background: linear-gradient(to right, #3b82f6, #2563eb);\n  color: #fff;\n  padding: 0.75rem 2rem;\n  font-family: inherit;\n  font-size: 1rem;\n  font-weight: 600;\n  border: none;\n  border-radius: 50px;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n  cursor: pointer;\n  transition: all 0.3s ease;\n  align-self: center;\n  margin-top: 1.5rem;\n}\n\n.submit-demo:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);\n} */\n\n\n\n\n\n\n\n\n/* Updated unified styling for both sections */\n.benefits-section {\n  padding: 6rem 1rem;\n}\n\n.benefits-container {\n  max-width: 1200px;\n  margin: 0 auto;\n}\n\n.tab-switcher {\n  display: flex;\n  justify-content: center;\n  margin-bottom: 4rem;\n  background: white;\n  border-radius: 50px;\n  padding: 4px;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);\n  max-width: 400px;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.tab-button {\n  padding: 0.8rem 2rem;\n  font-size: 1.1rem;\n  font-weight: 600;\n  border: none;\n  background: transparent;\n  border-radius: 50px;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  font-family: 'Poppins', sans-serif;\n}\n\n.tab-button.active {\n  background: #2563eb;\n  color: white;\n}\n\n/* Section Header - Title above description */\n.section-header {\n  text-align: center;\n  max-width: 800px;\n  margin: 0 auto 3rem;\n  padding: 0 1rem;\n\n  display: flex;\n  flex-direction: column;\n}\n\n.section-title {\n  font-size: 2.5rem;\n  font-weight: 700;\n  color: #1e293b;\n  margin-bottom: 1rem;\n  order: 1;\n}\n\n/* .section-description {\n  font-size: 1.2rem;\n  color: #64748b;\n  margin-bottom: 0;\n  line-height: 1.6;\n} */\n\n.section-description {\n  font-size: 1.2rem;\n  color: #64748b;\n  line-height: 1.6;\n  margin-top: 0;\n  order: 2; /* Explicitly places description second */\n  padding: 0 1rem; /* Adds some horizontal padding */\n}\n\n/* Unified card container */\n.benefits-card-container {\n  display: grid;\n  gap: 2rem;\n  align-items: stretch;\n}\n\n@media (min-width: 992px) {\n  .benefits-card-container {\n    grid-template-columns: 1fr 1fr;\n  }\n}\n\n/* Score card */\n.score-card {\n  background: white;\n  border-radius: 16px;\n  padding: 2rem;\n  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.05);\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n}\n\n.score-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 1.5rem;\n}\n\n.score-header h3 {\n  font-size: 1.25rem;\n  font-weight: 600;\n  color: #1e293b;\n}\n\n.overall-score {\n  background: #dbeafe;\n  color: #2563eb;\n  font-weight: 700;\n  padding: 0.5rem 1.25rem;\n  border-radius: 50px;\n}\n\n.score-categories {\n  display: grid;\n  gap: 1.5rem;\n}\n\n.category-header {\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: 0.5rem;\n  font-size: 0.95rem;\n  color: #475569;\n}\n\n.progress-bar {\n  height: 8px;\n  background: #e2e8f0;\n  border-radius: 4px;\n  overflow: hidden;\n  margin-top: 0.5rem;\n}\n\n.progress-fill {\n  height: 100%;\n  border-radius: 4px;\n}\n\n.education {\n  background: #10b981;\n}\n\n.transport {\n  background: #3b82f6;\n}\n\n.parks {\n  background: #f59e0b;\n}\n\n/* Benefit cards */\n.benefits-cards {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));\n  gap: 1.5rem;\n}\n\n.card {\n  background: white;\n  border-radius: 16px;\n  padding: 2rem;\n  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.05);\n  transition: all 0.3s ease;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n}\n\n.card:hover {\n  transform: translateY(-5px);\n  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1);\n}\n\n.card-icon {\n  width: 50px;\n  height: 50px;\n  background: #dbeafe;\n  border-radius: 12px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: 1.5rem;\n}\n\n.card-icon svg {\n  width: 24px;\n  height: 24px;\n  color: #2563eb;\n}\n\n.card h3 {\n  font-size: 1.25rem;\n  font-weight: 600;\n  color: #1e293b;\n  margin-bottom: 0.75rem;\n}\n\n.card p {\n  color: #64748b;\n  line-height: 1.6;\n  margin-bottom: 0;\n}\n\n/* Agents section */\n.agents-text {\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n}\n\n.benefits-list {\n  display: grid;\n  gap: 1.5rem;\n}\n\n.benefit-item {\n  display: flex;\n  gap: 1rem;\n  padding: 1.5rem;\n  background: white;\n  border-radius: 12px;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);\n  transition: all 0.3s ease;\n}\n\n.benefit-item:hover {\n  transform: translateY(-3px);\n  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1);\n}\n\n.benefit-icon {\n  width: 50px;\n  height: 50px;\n  background: #dbeafe;\n  border-radius: 12px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n\n.benefit-icon svg {\n  width: 24px;\n  height: 24px;\n  color: #2563eb;\n}\n\n.benefit-item h3 {\n  font-size: 1.25rem;\n  font-weight: 600;\n  color: #1e293b;\n  margin-bottom: 0.25rem;\n}\n\n.benefit-item p {\n  color: #64748b;\n  font-size: 1rem;\n  line-height: 1.6;\n  margin: 0;\n}\n\n/* Signup steps */\n.signup-details {\n  background: white;\n  border-radius: 16px;\n  padding: 2rem;\n  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.05);\n  height: 100%;\n}\n\n.signup-steps {\n  list-style: none;\n  padding: 0;\n  margin: 1rem 0 2rem;\n}\n\n.step {\n  display: flex;\n  gap: 1.5rem;\n  align-items: flex-start;\n  padding: 1.5rem;\n  background: white;\n  border-radius: 12px;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);\n  transition: all 0.3s ease;\n  margin-bottom: 1rem;\n}\n\n.step:hover {\n  transform: translateY(-3px);\n  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1);\n}\n\n.step-icon {\n  width: 50px;\n  height: 50px;\n  background: #dbeafe;\n  border-radius: 12px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n\n.step-icon svg {\n  width: 24px;\n  height: 24px;\n  color: #2563eb;\n}\n\n.step-content h3 {\n  font-size: 1.25rem;\n  font-weight: 600;\n  color: #1e293b;\n  margin-bottom: 0.5rem;\n}\n\n.step-content p {\n  color: #64748b;\n  font-size: 1rem;\n  line-height: 1.6;\n  margin: 0;\n}\n\n/* CTA buttons */\n.cta-buttons {\n  display: flex;\n  gap: 1rem;\n  margin-top: 2rem;\n  justify-content: center;\n}\n\n.cta-button {\n  padding: 0.75rem 1.5rem;\n  font-family: 'Poppins', sans-serif;\n  font-size: 1rem;\n  font-weight: 600;\n  border: none;\n  border-radius: 50px;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.cta-button.primary {\n  background: #2563eb;\n  color: #fff;\n}\n\n.cta-button.primary:hover {\n  background: #1e40af;\n}\n\n.cta-button.secondary {\n  background: #fff;\n  color: #2563eb;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);\n}\n\n.cta-button.secondary:hover {\n  background: #f1f5f9;\n}\n\n/* Demo form */\n.demo-form {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n  margin-top: 1.5rem;\n}\n\n.demo-form input,\n.demo-form textarea {\n  font-family: inherit;\n  font-size: 1rem;\n  padding: 0.75rem 1rem;\n  border: 1px solid #cbd5e1;\n  border-radius: 0.5rem;\n  outline: none;\n  resize: vertical;\n}\n\n.demo-form input:focus,\n.demo-form textarea:focus {\n  border-color: #2563eb;\n  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.2);\n}\n\n.submit-demo {\n  background: linear-gradient(to right, #3b82f6, #2563eb);\n  color: #fff;\n  padding: 0.75rem 2rem;\n  font-family: inherit;\n  font-size: 1rem;\n  font-weight: 600;\n  border: none;\n  border-radius: 50px;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n  cursor: pointer;\n  transition: all 0.3s ease;\n  align-self: center;\n  margin-top: 1.5rem;\n}\n\n.submit-demo:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
